import { z } from "zod/mini";
import type { DatabaseProperties } from ":shared/database/database-properties";

export const TagSchema = z.object({
	label: z.string(),
	description: z.optional(z.string()),
	isSystem: z.optional(z.boolean()),
});

export type Tag = z.infer<typeof TagSchema>;
export type TagIdentifiable = Tag & DatabaseProperties;

export function createTag(input: Tag): Tag {
	const parsed = TagSchema.parse(input);
	return parsed;
}
